import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/public/Navbar";
import Footer from "@/components/public/Footer";
import FloatingCtas from "@/components/public/FloatingCtas";
import { getSettings, getDigitalCard } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";

export default function PublicLayout() {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  const { data: card } = useQuery({ queryKey: ["digital-card"], queryFn: getDigitalCard });
  const { lang } = useLanguage();
  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className={`min-h-screen flex flex-col bg-white ${lang === "kn" ? "lang-kn" : ""}`}>
      <Navbar settings={settings} />
      <main className="flex-1">
        <Outlet context={{ settings }} />
      </main>
      <Footer settings={settings} card={card} />
      <FloatingCtas settings={settings} />
      <div className="md:hidden h-16" />
    </div>
  );
}
